import React, { Component } from 'react';
import { Button, Icon } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route } from "react-router";

import { actions } from "store";
import { Page, PageHeader } from 'components/layout';
import { ActionButton } from "components/common";
import { CountryForm } from 'components/blocks/geo';
import CountryCityListScreen from './CountryCityListScreen';
import CountryProfileListScreen from './CountryProfileListScreen';

class CountryScreen extends Component {
    state = {
        id: null,
    };

    componentDidMount() {
        const { actions, match } = this.props;
        actions.geoCountryDetailLoad({ id: match.params.id });
        this.setState({ id: match.params.id });
    }

    showEditForm = (item = null) => {
        const { actions } = this.props;
        actions.geoCountryShowEditForm({ show: true, object: item });
    };

    delete = () => {
        const { actions } = this.props;
        const { id } = this.state;
        actions.geoCountryDelete({ id });
    };

    render() {
        const { history, geo_country } = this.props;
        const detail = geo_country.detail || {};

        return (
            <Page>
                <PageHeader
                    history={history}
                    title={detail.name_en}
                    actions={[
                        <Button onClick={() => this.showEditForm(detail)}>
                            <Icon type="edit"/>
                            <span>Редактировать</span>
                        </Button>,
                        <ActionButton
                            actions={[
                                {
                                    key: 'delete',
                                    icon: <Icon type="delete"/>,
                                    title: 'Удалить',
                                    action: this.delete,
                                    confirm: {
                                        title: 'Уверены, что хотите удалить?',
                                        okText: 'Удалить',
                                        cancelText: 'Отмена'
                                    }
                                },
                            ]}

                        />
                    ]}
                    basePath={`/country/${this.state.id}`}
                    tabs={[
                        { title: 'Города', key: 'detail' },
                        { title: 'Анкеты', key: 'profiles' },
                    ]}
                />

                <Route exact path="/country/:id" component={CountryCityListScreen}/>
                <Route exact path="/country/:id/profiles" component={CountryProfileListScreen}/>

                <CountryForm/>
            </Page>
        );
    }
}


function mapStateToProps(state) {
    return {
        geo_country: state.geo_country,
    };
}


function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, actions.geo_country), dispatch),
        dispatch: dispatch
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(CountryScreen);
